import React from "react"
import PropTypes from "prop-types"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { Link } from "gatsby"
import { Container } from "../Container"

import { linksResolver } from "../../utils/linksResolver"

import { Icon } from "../Icon"

import styled from "styled-components"
import { MainBackground } from "../MainBackground"

const TeamGrid = ({ slice }) => {
  const { items } = slice
  const { heading, size } = slice.primary
  return (
    <MainBackground>
      <section>
        <Container>
          <div dangerouslySetInnerHTML={{ __html: heading.html }} />
          <Links>
            {items.map((item, i) => {
              const { person } = item
              if (!person) return null
              const { name, title, linkedin, photo, photoBig } =
                person.document.data
              const personPhoto = size === "Big" ? photoBig : photo
              const personimage = getImage(personPhoto)
              return (
                <li key={i}>
                  <AuthorImage>
                    {" "}
                    <GatsbyImage image={personimage} alt={name ?? ""} />
                  </AuthorImage>
                  {name && <Link to={linksResolver(person)}>{name}</Link>}
                  {title && <p>{title}</p>}
                  {linkedin.type ? (
                    <a href={linksResolver(linkedin)}>
                      {" "}
                      <Icon type="LINKEDIN" />
                    </a>
                  ) : (
                    <a href={linkedin.url} target={linkedin.target}>
                      <Icon type="LINKEDIN" />
                    </a>
                  )}
                </li>
              )
            })}
          </Links>
        </Container>
      </section>
    </MainBackground>
  )
}

TeamGrid.propTypes = {
  slice: PropTypes.object.isRequired,
}

export default TeamGrid

const Links = styled.ul`
  list-style: none;
  padding: 0;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  margin: 0 -32px;

  @media (max-width: 767px) {
    justify-content: center;
  }
  li {
    width: 176px;
    margin: 32px;
    @media only screen and (min-width: 600px) and (max-width: 710px) {
      width: 220px;
    }
    @media (max-width: 599px) {
      width: 100%;
    }
  }
  a {
    font-size: 20px;
    line-height: 24px;
    font-weight: bold;
    display: inline-block;
    color: #000;
    margin: 0px 0 0 0;
    @media (max-width: 479px) {
      font-size: 16px;
      line-height: 20px;
    }
  }
  p {
    font-size: 20px;
    line-height: 24px;
    font-weight: 400;
    margin: 4px 0px 8px;
    color: #000;
    @media (max-width: 479px) {
      font-size: 15px;
      line-height: 20px;
    }
  }
`
const AuthorImage = styled.div`
  justify-content: center;
  margin-bottom: 21px;
  display: flex;
  img {
    border-radius: 50%;
  }
`
